import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import portalService from '../../services/portalService';
import { usePortalAuth } from '../../context/PortalAuthContext';
import { useLanguage, t } from '../../context/LanguageContext';

const COMPANY_ID = process.env.REACT_APP_COMPANY_ID || 1;

export default function PortalLoginPage() {
  const { login } = usePortalAuth();
  const { lang } = useLanguage();
  const navigate = useNavigate();

  const [badgeNumber, setBadgeNumber] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [locked, setLocked] = useState(null); // minutes
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLocked(null);
    setLoading(true);
    try {
      const data = await portalService.login(Number(badgeNumber), password, COMPANY_ID);
      login(data.token, data.employee, data.mustChangePassword);
      navigate(data.mustChangePassword ? '/portal/change-password' : '/portal');
    } catch (err) {
      const msg = err.response?.data?.message || t('Login failed.', 'Error al iniciar sesión.', lang);
      const mins = err.response?.data?.lockedMinutes;
      if (mins) setLocked(mins);
      else setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6fa', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div className="text-center mb-4">
          <div style={{ fontSize: 36, marginBottom: 4 }}>🏭</div>
          <h4 className="fw-bold mb-0">{t('Employee Portal', 'Portal de empleados', lang)}</h4>
          <p className="text-muted" style={{ fontSize: 13 }}>{t('Sign in with your badge number and password', 'Ingrese con su número de gafete y contraseña', lang)}</p>
        </div>

        <div className="card shadow-sm">
          <div className="card-body p-4">
            {locked && (
              <div className="alert alert-warning" style={{ fontSize: 13 }}>
                {t('Account temporarily locked. Try again in', 'Cuenta bloqueada temporalmente. Intente de nuevo en', lang)}{' '}
                <strong>{locked} {locked !== 1 ? t('minutes', 'minutos', lang) : t('minute', 'minuto', lang)}</strong>.
              </div>
            )}
            {error && (
              <div className="alert alert-danger" style={{ fontSize: 13 }}>{error}</div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label" style={{ fontSize: 13, fontWeight: 600 }}>{t('Badge Number', 'Número de gafete', lang)}</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder={t('Enter your badge number', 'Ingrese su número de gafete', lang)}
                  value={badgeNumber}
                  onChange={e => setBadgeNumber(e.target.value)}
                  required
                  autoComplete="username"
                />
              </div>
              <div className="mb-4">
                <label className="form-label" style={{ fontSize: 13, fontWeight: 600 }}>{t('Password', 'Contraseña', lang)}</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder={t('Enter your password', 'Ingrese su contraseña', lang)}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                />
              </div>
              <button className="btn btn-primary w-100" type="submit" disabled={loading || !!locked}>
                {loading ? t('Signing in…', 'Iniciando sesión…', lang) : t('Sign In', 'Iniciar sesión', lang)}
              </button>
            </form>
          </div>
        </div>

        <p className="text-center text-muted mt-3" style={{ fontSize: 12 }}>
          {t('Forgot your password? Contact your manager.', '¿Olvidó su contraseña? Contacte a su supervisor.', lang)}
        </p>
      </div>
    </div>
  );
}
